import { render } from "./RegisterUserForm.vue?vue&type=template&id=1f6b7c9e"
import script from "./RegisterUserForm.vue?vue&type=script&lang=js"
export * from "./RegisterUserForm.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\COSMI\\Desktop\\appwebantiguo\\vue-op-vanguardia\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__